import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  const status = err?.response?.status;
  if (status === 404) return "That service isn't available right now — please try again in a moment.";
  if (status === 429) return "Too many attempts — please wait a few minutes and try again.";
  if (status >= 500) return "Something went wrong on our side — please try again in a moment.";
  if (err?.code === "ERR_NETWORK") return "Can't reach the server — check your connection and try again.";
  return err?.message || "Something went wrong. Please try again.";
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const token = localStorage.getItem("sk_token");
    if (!token) {
      setUser(null);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("sk_token");
        setUser(null);
      });
  }, []);

  const save = (data) => {
    localStorage.setItem("sk_token", data.access_token);
    setUser(data.user);
  };

  const login = async (email, password) => save((await api.post("/auth/login", { email, password })).data);
  const register = async (name, email, password, agreeTerms = false) =>
    save((await api.post("/auth/register", { name, email, password, agree_terms: agreeTerms })).data);
  const refreshUser = async () => {
    const r = await api.get("/auth/me");
    setUser(r.data);
    return r.data;
  };
  const logout = () => {
    localStorage.removeItem("sk_token");
    setUser(null);
  };

  return <AuthContext.Provider value={{ user, login, register, logout, refreshUser }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
